import type { AreaSuggestionDivider } from "./_utils/area-filtering";

type CalendarAreaSuggestionDividerProps = {
  suggestion: AreaSuggestionDivider;
};

function getMessage(suggestion: AreaSuggestionDivider): string {
  if (suggestion.kind === "area-only") {
    return "希望のエリア外のお部屋";
  }
  if (suggestion.selectedAreaAllEmpty) {
    return "希望のエリア外なら条件の合うお部屋があります";
  }
  return "希望のエリア外にも条件の合うお部屋があります";
}

export function CalendarAreaSuggestionDivider({
  suggestion,
}: CalendarAreaSuggestionDividerProps) {
  return (
    <div className="border-skogecha-16 bg-slightbeige-100 flex items-center justify-center border-b px-[20px] py-[12px]">
      <p className="font-notojp text-skogecha-60 text-[12px] leading-[1.6]">
        {getMessage(suggestion)}
      </p>
    </div>
  );
}
